import Entry from "./components/Entry";
import Manifesto from "./components/Manifesto";
import Evidence from "./components/Evidence";
import Skills from "./components/Skills";
import Mind from "./components/Mind";
import Signal from "./components/Signal";

function App() {
  return (
    <main>
      <Entry />
      <Manifesto />
      <Evidence />
      <Skills />
      <Mind />
      <Signal />
    </main>
  );
}

export default App;
